import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import ApplicationLayout from 'Components/ApplicationLayout';
import NoSSR from 'Components/NoSSR';
import HomeSkeleton from './HomeSkeleton';

const Home = loadable(() => import('./Home'), {
  fallback: (
    <div className="page page--home page--home--skeleton">
      <HomeSkeleton />
    </div>
  )
});

const AsyncHome = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: 'full',
    hideStickyNavigation: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-smoke-grey`
      },
      script: [
        {
          defer: 'defer',
          src: '/public/thirdParty/swiper/swiper.js'
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/swiper/swiper.css',
          media: 'print',
          onload: "this.media='all'"
        }
      ]
    }
  };

  return (
    <NoSSR>
      <ApplicationLayout { ...pageConfig } { ...props }>
        <Home
          { ...props }
        />
      </ApplicationLayout>
    </NoSSR>
  );
};

AsyncHome.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncHome;
